import { Moment } from 'moment';

import {
  BiannualAppointmentStatus,
  BiannualStatus,
  EstablishedVisitStatus,
} from '../../enums';
import { translate } from '../../i18n';
import { makeUnix } from '../Model';
import { PodReportingDataExtended } from '../PodReportingDataExtended';

const makeBiannual = (obj: any) =>
  obj
    ? [
        new PodReportingDataExtended({
          id: BiannualStatus.DUE.value,
          name: translate('podReporting.table.due'),
          total: obj.npBiannualDueCount || 0,
          subtotals: [
            {
              id: BiannualAppointmentStatus.COMPLETED.value,
              name: BiannualAppointmentStatus.COMPLETED.toString(),
              total: obj.npBiannualCompletedDueCount || 0,
              __order: 1,
            },
            {
              id: BiannualAppointmentStatus.PENDING.value,
              name: BiannualAppointmentStatus.PENDING.toString(),
              total: obj.npBiannualPendingDueCount || 0,
              __order: 2,
            },
            {
              id: BiannualAppointmentStatus.RESCHEDULE_NEEDED.value,
              name: BiannualAppointmentStatus.RESCHEDULE_NEEDED.toString(),
              total: obj.npBiannualRescheduleDueCount || 0,
              __order: 3,
            },
            {
              id: BiannualAppointmentStatus.RESCHEDULE_FUTURE_MONTH.value,
              name: BiannualAppointmentStatus.RESCHEDULE_FUTURE_MONTH.toString(),
              total: obj.npBiannualPendingFutureDueCount || 0,
              __order: 4,
            },
            {
              id: BiannualAppointmentStatus.NOT_YET_SCHEDULED.value,
              name: BiannualAppointmentStatus.NOT_YET_SCHEDULED.toString(),
              total: obj.npBiannualNotYetDueCount || 0,
              __order: 5,
            },
          ],
        }),
        new PodReportingDataExtended({
          id: BiannualStatus.OVERDUE.value,
          name: translate('podReporting.table.overdue'),
          total: obj.npBiannualOverdueCount,
          subtotals: [
            {
              id: BiannualAppointmentStatus.COMPLETED.value,
              name: BiannualAppointmentStatus.COMPLETED.toString(),
              total: obj.npBiannualCompletedOverdueCount || 0,
              __order: 1,
            },
            {
              id: BiannualAppointmentStatus.PENDING.value,
              name: BiannualAppointmentStatus.PENDING.toString(),
              total: obj.npBiannualPendingOverdueCount || 0,
              __order: 2,
            },
            {
              id: BiannualAppointmentStatus.RESCHEDULE_NEEDED.value,
              name: BiannualAppointmentStatus.RESCHEDULE_NEEDED.toString(),
              total: obj.npBiannualRescheduleOverdueCount || 0,
              __order: 3,
            },
            {
              id: BiannualAppointmentStatus.RESCHEDULE_FUTURE_MONTH.value,
              name: BiannualAppointmentStatus.RESCHEDULE_FUTURE_MONTH.toString(),
              total: obj.npBiannualPendingFutureOverdueCount || 0,
              __order: 4,
            },
            {
              id: BiannualAppointmentStatus.NOT_YET_SCHEDULED.value,
              name: BiannualAppointmentStatus.NOT_YET_SCHEDULED.toString(),
              total: obj.npBiannualNotYetOverdueCount || 0,
              __order: 5,
            },
          ],
        }),
      ]
    : null;

const makeEstablished = (obj: any) =>
  obj
    ? [
        new PodReportingDataExtended({
          id: EstablishedVisitStatus.RECONSENT_COMPLEX.value,
          name: EstablishedVisitStatus.RECONSENT_COMPLEX.toString(),
          total: obj.establishedVisitReconsentComplexCount || 0,
          subtotals: [
            {
              id: BiannualAppointmentStatus.COMPLETED.value,
              name: BiannualAppointmentStatus.COMPLETED.toString(),
              total: obj.establishedVisitCompletedReconsentComplexCount || 0,
              __order: 1,
            },
            {
              id: BiannualAppointmentStatus.PENDING.value,
              name: BiannualAppointmentStatus.PENDING.toString(),
              total: obj.establishedVisitPendingReconsentComplexCount || 0,
              __order: 2,
            },
            {
              id: BiannualAppointmentStatus.RESCHEDULE_NEEDED.value,
              name: BiannualAppointmentStatus.RESCHEDULE_NEEDED.toString(),
              total: obj.establishedVisitRescheduleReconsentComplexCount || 0,
              __order: 3,
            },
            {
              id: BiannualAppointmentStatus.RESCHEDULE_FUTURE_MONTH.value,
              name: BiannualAppointmentStatus.RESCHEDULE_FUTURE_MONTH.toString(),
              total:
                obj.establishedVisitPendingFutureReconsentComplexCount || 0,
              __order: 4,
            },
            {
              id: BiannualAppointmentStatus.NOT_YET_SCHEDULED.value,
              name: BiannualAppointmentStatus.NOT_YET_SCHEDULED.toString(),
              total: obj.establishedVisitNotYetReconsentComplexCount || 0,
              __order: 5,
            },
          ],
        }),
        new PodReportingDataExtended({
          id: EstablishedVisitStatus.RECONSENT_ONLY.value,
          name: EstablishedVisitStatus.RECONSENT_ONLY.toString(),
          total: obj.establishedVisitReconsentCount,
          subtotals: [
            {
              id: BiannualAppointmentStatus.COMPLETED.value,
              name: BiannualAppointmentStatus.COMPLETED.toString(),
              total: obj.establishedVisitCompletedReconsentCount || 0,
              __order: 1,
            },
            {
              id: BiannualAppointmentStatus.PENDING.value,
              name: BiannualAppointmentStatus.PENDING.toString(),
              total: obj.establishedVisitPendingReconsentCount || 0,
              __order: 2,
            },
            {
              id: BiannualAppointmentStatus.RESCHEDULE_NEEDED.value,
              name: BiannualAppointmentStatus.RESCHEDULE_NEEDED.toString(),
              total: obj.establishedVisitRescheduleReconsentCount || 0,
              __order: 3,
            },
            {
              id: BiannualAppointmentStatus.RESCHEDULE_FUTURE_MONTH.value,
              name: BiannualAppointmentStatus.RESCHEDULE_FUTURE_MONTH.toString(),
              total: obj.establishedVisitPendingFutureReconsentCount || 0,
              __order: 4,
            },
            {
              id: BiannualAppointmentStatus.NOT_YET_SCHEDULED.value,
              name: BiannualAppointmentStatus.NOT_YET_SCHEDULED.toString(),
              total: obj.establishedVisitNotYetReconsentCount || 0,
              __order: 5,
            },
          ],
        }),
        new PodReportingDataExtended({
          id: EstablishedVisitStatus.COMPLEX_ONLY.value,
          name: EstablishedVisitStatus.COMPLEX_ONLY.toString(),
          total: obj.establishedVisitComplexCount,
          subtotals: [
            {
              id: BiannualAppointmentStatus.COMPLETED.value,
              name: BiannualAppointmentStatus.COMPLETED.toString(),
              total: obj.establishedVisitCompletedComplexCount || 0,
              __order: 1,
            },
            {
              id: BiannualAppointmentStatus.PENDING.value,
              name: BiannualAppointmentStatus.PENDING.toString(),
              total: obj.establishedVisitPendingComplexCount || 0,
              __order: 2,
            },
            {
              id: BiannualAppointmentStatus.RESCHEDULE_NEEDED.value,
              name: BiannualAppointmentStatus.RESCHEDULE_NEEDED.toString(),
              total: obj.establishedVisitRescheduleComplexCount || 0,
              __order: 3,
            },
            {
              id: BiannualAppointmentStatus.RESCHEDULE_FUTURE_MONTH.value,
              name: BiannualAppointmentStatus.RESCHEDULE_FUTURE_MONTH.toString(),
              total: obj.establishedVisitPendingFutureComplexCount || 0,
              __order: 4,
            },
            {
              id: BiannualAppointmentStatus.NOT_YET_SCHEDULED.value,
              name: BiannualAppointmentStatus.NOT_YET_SCHEDULED.toString(),
              total: obj.establishedVisitNotYetComplexCount || 0,
              __order: 5,
            },
          ],
        }),
      ]
    : null;

export class PodReportingVisit {
  biannual: PodReportingDataExtended[];

  established: PodReportingDataExtended[];

  lastUpdatedAt?: Moment;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.biannual = makeBiannual(obj.biannuals) || [];
    this.established = makeEstablished(obj.establishedVisits) || [];
    this.lastUpdatedAt = makeUnix(obj.lastUpdatedAt);
  }
}

export default PodReportingVisit;
